/**
 * User entity DTOs
 * Extracted from src/types/admin/user.ts - API contract types only
 */

/** Cognito status of a user that was invited but has not set a password yet */
export const INVITE_PENDING_STATUS = 'FORCE_CHANGE_PASSWORD';

/**
 * User data as received from the backend API
 */
export interface UserData {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  groups: string[];
  isProvider: boolean;
  providerType?: string | null;
  /** @deprecated legacy name for licenseNumber */
  license?: string | null;
  /** Professional license number (Phase 5) */
  licenseNumber?: string | null;
  /** License expiry date, YYYY-MM-DD (Phase 5) */
  licenseExpiry?: string | null;
  npi?: string | null;
  phone?: string | null;
  status?: string;
  photoUrl?: string;
  /** ISO timestamp of the last sign-in, or null if the user never signed in (Phase 5) */
  lastLoginAt?: string | null;
  /** Cognito user status; FORCE_CHANGE_PASSWORD means the invite is pending (Phase 5) */
  cognitoStatus?: string | null;
  /** True while the invite is pending; null when the backend could not tell (Phase 5) */
  invitePending?: boolean | null;
  /** HHAX 3rd Party Caregiver Code, ≤20 characters (Phase 9A, D5) */
  clinicianCode?: string | null;
}

/** Raw user object from GET /users, GET /users/{id}, POST /users, PUT /users/{id} */
export interface UserApiDto {
  userId?: string;
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  roles?: string[];
  providerType?: string | null;
  status?: string;
  photoUrl?: string;
  licenseNumber?: string | null;
  licenseExpiry?: string | null;
  lastLoginAt?: string | null;
  cognitoStatus?: string | null;
  invitePending?: boolean | null;
  clinicianCode?: string | null;
  pii?: {
    phone?: string | null;
    license?: string | null;
    licenseNumber?: string | null;
    licenseExpiry?: string | null;
    npi?: string | null;
  };
}

/** Response of GET /users/access-review (same handling as the audit log download) */
export interface AccessReviewDownloadResponse {
  downloadUrl?: string;
  fileName?: string;
  /** Some deployments return the CSV inline */
  csv?: string;
  content?: string;
}
